$(function() {
    new WOW().init();
});